/** Shared typography on Measure screen — matches Profile / Home (Inter, design tokens). */

export const measureEyebrow =
  "text-compact-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground";

export const measureEyebrowWarning =
  "text-compact-xs font-semibold uppercase tracking-[0.12em] text-amber-600 dark:text-amber-400";

export const measureSectionTitle = "text-xl font-semibold text-foreground";

export const measurePageTitle = "text-2xl font-semibold text-foreground";

/** Eyebrow above page title (e.g. "Health metrics") */
export const measurePageSubtitle = "text-compact-sm font-medium text-muted-foreground";

export const measureCardTitle = "text-callout font-semibold leading-tight text-foreground";

/** Card row title — bold subhead */
export const measureCardHeading = "text-subhead font-bold leading-tight text-foreground";

export const measureCardValue = "text-callout font-semibold leading-tight text-foreground";

/** Card row value — semibold subhead */
export const measureCardValueSubhead = "text-subhead font-semibold leading-tight text-foreground";

export const measureCardMeta = "text-compact-xs font-medium uppercase tracking-wide text-muted-foreground";

export const measureCardMetaWarning =
  "text-compact-xs font-medium uppercase tracking-wide text-amber-600 dark:text-amber-400";

export const measureBody = "text-sm leading-relaxed text-muted-foreground";

export const measureActionLabel =
  "text-compact-xs font-bold uppercase tracking-[0.08em] text-foreground";

export const measurePrimaryButtonLabel =
  "text-compact-xs font-bold uppercase tracking-[0.08em] text-primary-foreground";

/** Focus card headline (Your focus) */
export const measureFocusTitle =
  "text-title3 font-semibold leading-snug text-foreground sm:text-title2";

/** Focus card description */
export const measureFocusBody = "text-footnote leading-relaxed text-muted-foreground";
